// extracted by mini-css-extract-plugin
export var standaloneTable = "_27-0";
export var standaloneTableWithBodyFill = "_27-1";
export var withExtraHeader = "_27-2";